import { useCallback } from 'react';
import { useQuery, useQueryClient } from 'react-query';

import { Group, GroupType } from '../api/api';
import { useAxios } from '../context/AxiosContext';

export interface GroupSearchPayload {
  type?: GroupType;
  search: string;
}

export function useGroupQuery({ type = undefined, search }: Partial<GroupSearchPayload>) {
  const queryCache = useQueryClient();
  const { authAxios } = useAxios();

  const fetchGroups = useCallback(
    async (_: string, filter?: GroupType, term?: string): Promise<Group[]> => {
      const url: string = term ? `/group/search/${term}` : '/group';
      const response = await authAxios.get<any>(url, {
        params: {
          filter
        }
      });
      return response.data;
    },
    [authAxios]
  );

  const { status, data, isFetching } = useQuery(['group', type, search], () => fetchGroups('group', type, search), {
    refetchOnWindowFocus: false,
    enabled: type !== undefined && type !== GroupType.DRAFT,
    onError: () => {
      // Invalidate Query only if there is no successfull response
      queryCache.invalidateQueries(['group', type, search]);
    }
  });

  return { values: data, isGroupsFetching: isFetching, groupStatus: status };
}
